<template>
  <el-dialog :visible="visible" :title="$t('SeaExport.BookingAudit')" width="600px" custom-class="cargo-form-dialog" :close-on-click-modal="false" @close="handleClose">
    <el-form ref="form" label-width="90px" label-position="left" class="cargo-form">
      <el-row v-if="isDifferentJobOrBusinessFieldValues" :gutter="10">
        <el-col :span="24">
          <el-form-item label-width="0" class="auto-width">
            <i class="el-icon-warning" style="color: #e6a23c;margin-left: 5px" />
            <span style="font-size: 12px;">{{ $t('Message.DifferentJobOrBusinessFieldValues') }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.OperationCompany') }}：</span>
            <cargo-office-select
              no="opOffice"
              :clearable="false"
              :have-hq="false"
              :disabled="isTrustFrom"
              :office-id="Number(job.opOffice)"
              tag-name="code"
              tooltip
              @change="p=>{job.opOffice=p.value;officeChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Operation')+'：'">
            <cargo-user-select
              no="op"
              :method-params="{officeId:job.opOffice,category:'role',shape:'op'}"
              :default-value="job.op||''"
              :placeholder="differentForm.op ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.Operation')"
              @change="p=>{job.op=p.value;differentForm.op=true;opChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <span slot="label" :class="isBatchUpdate ? '' : 'blue'">{{ $t('SeaExport.OperationDepartment') }}：</span>
            <cargo-department-select
              no="opDepartment"
              :office-id="Number(job.opOffice) || $store.getters.currentOfficeId"
              :department-id="Number(job.opDepartment)"
              :placeholder="differentForm.opDepartment ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.OperationDepartment')"
              @change="p=>{job.opDepartment=p.value;differentForm.opDepartment=true;}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.CustomerService')+'：'">
            <cargo-user-select
              ref="csr"
              no="csr"
              :method-params="{officeId:(isTrustFrom || job.salesOffice===1)?job.opOffice:job.salesOffice,category:'role',shape:'csr'}"
              :default-value="job.csr||''"
              :placeholder="differentForm.csr ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.CustomerService')"
              @change="p=>{job.csr=p.value;differentForm.csr=true;csrChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Documents')+'：'">
            <cargo-user-select
              ref="dc"
              no="dc"
              :method-params="{officeId:job.opOffice,category:'role',shape:'doc'}"
              :default-value="job.dc||''"
              :placeholder="differentForm.dc ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.Documents')"
              @change="p=>{job.dc=p.value;differentForm.dc=true;dcChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.ContractRateProperty')+'：'">
            <el-select
              v-model="job.bookingTerm"
              no="bookingTerm"
              :clearable="false"
              size="mini"
              :placeholder="differentForm.bookingTerm ? $t('SeaExport.PleaseSelect') : $t('Message.PreserveOriginalValue') + $t('SeaExport.ContractRateProperty')"
              @change="p=>{differentForm.bookingTerm=true;bookingTermChangeHandler}"
            >
              <el-option
                v-for="(item,index) in bookingTerms"
                :key="index"
                :no="item.code"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.BookingAgent')+'：'" class="red-input">
            <cargo-advance-select
              no="bookingAgent"
              :select-type="selectTypeNames.basic_data_Company"
              filterable
              :method-params="{bookingAgent:true,companyLob:'seaExport',active:true}"
              :default-value="job.bookingAgent||''"
              :placeholder="differentForm.bookingAgent ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.BookingAgent')"
              @parentCallBack="p=>{job.bookingAgent=p.value;differentForm.bookingAgent=true;}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.ShippingCompanyContractNo')+'：'">
            <el-input
              v-model="job.scNo"
              no="scNo"
              :placeholder="differentForm.scNo ? '' : $t('Message.PreserveOriginalValue') + $t('SeaExport.ShippingCompanyContractNo')"
              @change="p=>{differentForm.scNo=true;}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.Remarks')+'：'">
            <el-input v-model="job.remarks" type="textarea" no="remarks" :rows="2" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" style="padding:10px;">
      <el-button type="primary" no="confirm" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button no="cancel" @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import CargoForm from '@/components/Cargo/Common/CargoForm'
import { BOOKING_TERMS } from '@/class/cargo/model/parameters/SeaExportConstants'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { Company } from '@/class/model/mdm/Company'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import { getSeaImportJobByUuid } from '@/api/SeaImport/seaImportJob'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'OpVerifyFrameConfirmDialog',
  components: { cargoDepartmentSelect, cargoOfficeSelect, cargoUserSelect, cargoCompanySelect, cargoAdvanceSelect, CargoForm },
  props: {
    visible: { type: Boolean, default: () => false },
    jobModel: { type: Object, default: () => ({}) },
    submitCallBack: { type: Function, default: () => (null) },
    jobList: { type: Array, default: () => ([]) }
  },
  data() {
    return {
      job: {
        op: 0,
        opOffice: 0,
        opDepartment: 0,
        csr: 0,
        dc: 0,
        bookingTerm: 'OS',
        bookingAgent: 0,
        scNo: '',
        remarks: ''
      },
      selectTypeNames: TYPE_NAMES,
      isTrustFrom: false,
      innerVisible: false,
      isDisplayOP: true,
      popperClass: '#E9650E',
      bookingTerms: BOOKING_TERMS, // 约价性质
      differentForm: {
        op: true,
        opDepartment: true,
        csr: true,
        dc: true,
        bookingTerm: true,
        bookingAgent: true,
        scNo: true
      },
      isDifferentJobOrBusinessFieldValues: false
    }
  },
  computed: {
    isBatchUpdate() { // 是否批量修改
      return this.jobList && this.jobList.length > 1
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        if (newVal) {
          await this.init()
        }
      }
    }
  },
  async created() {
  },
  methods: {
    async init() {
      Object.assign(this.job, this.jobModel)
      const dbJob = await getSeaImportJobByUuid(this.jobModel.uuid).then((res) =>
        res.data ? res.data : null
      )
      if (dbJob) Object.assign(this.job, dbJob)
      this.job.opOffice = this.job.opOffice || 1
      this.job.bookingTerm = this.job.bookingTerm || 'OS'
      this.isDisplayOP = this.job.bookingTerm === BookingTerm.OS_BOOKING_TYPE.code
      this.isTrustFrom = await this.checkTrustFrom()

      const deps = getCacheListByKey(basicCacheKeys.basic_data_Department)
      let officeId = ''
      if (this.job.opDepartment && this.job.opDepartment > 0 && deps && deps.length > 0) {
        let officeUuid = ''
        const dep = deps.find(p => p.departmentId === this.job.opDepartment)
        if (dep) officeUuid = dep.officeUuid
        if (officeUuid) {
          const officeList = getCacheListByKey(basicCacheKeys.basic_data_Office)
          const office = officeList.find(p => p.uuid === officeUuid)
          if (office) officeId = office.officeId
        }
      }
      if ((officeId && officeId !== this.job.opOffice)) {
        this.job.opDepartment = 0
      }
      this.isDifferentJobOrBusinessFieldValues = JobUtils.verifyCheckJobFieldDifferent(this.job, this.jobList, this.differentForm, SystemConstants.SI.code)
    },
    // 非委托单｛ job.salesOffice=当前分公司
    // and (job.trustFromJob is null or job.trustFromJob = '') and 委托单位不是内部公司)｝
    // 则客服跟销售公司，允许修改操作公司，否则委托单客服跟操作公司，不允许修改操作公司
    async checkTrustFrom() {
      const company = await Company.getCompanyById(this.job.customerId)
      const currentOfficeId = this.$store.getters.currentOfficeId
      if (this.job.salesChannel === 'B2B') { return false }
      if ((this.job.salesOffice && parseInt(this.job.salesOffice) === currentOfficeId && !this.job.trustFromJob && company && company.linkedBranchId === 0) || (this.job.salesOffice === 1)) {
        return false // 非委托单
      }
      return true
    },
    // 切换分公司
    officeChangeHandler() {
      if (!this.job.opOffice || this.job.opOffice <= 0) {
        this.job.opOffice = this.$store.getters.currentOfficeId
      }
    },
    // 选择操作时，获取操作分公司
    opChangeHandler(user) {
      if (user.defaultDepId > 0) {
        this.job.opDepartment = user.defaultDepId
      } else {
        if (this.job.opOffice > 0) {
          new User(user).getUserDefaultDepartmentByOffice('role', 'op', this.job.opOffice).then(dep => {
            this.job.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          new User(user).getDefaultDepartment('role', 'op', this.job.opOffice).then(dep => {
            this.job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    },
    // 客服改变
    async csrChangeHandler(data) {
      this.job.csr = data.value
      this.job.csrDepartment = 0
      this.job.csrOffice = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'csr')
        if (dep) {
          this.job.csrDepartment = dep.departmentId
          const office = await Office.getOfficeByUuid(dep.officeUuid)
          this.job.csrOffice = office ? office.officeId : 0
        }
      }
    },
    // 单证改变
    async dcChangeHandler(data) {
      this.job.dc = data.value
      this.job.dcDepartment = 0
      this.job.dcOffice = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'doc')
        this.job.dcDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        this.job.dcOffice = office ? office.officeId : 0
      } else {
        this.job.dc = 0
        this.job.dcDepartment = 0
        this.job.dcOffice = 0
      }
    },
    // 约价性质
    bookingTermChangeHandler() {
      this.isDisplayOP = this.job.bookingTerm === BookingTerm.OS_BOOKING_TYPE.code
    },
    handleSubmit() {
      // if ((!this.job.op || this.job.op <= 0) && this.job.salesChannel === 'JJCARGO') {
      //   this.$message.warning(this.$t('SeaExport.OperationCannotBeEmpty'))
      //   return
      // }
      if (!this.job.opOffice || this.job.opOffice === 1 || this.job.opOffice <= 0) {
        this.$message.warning(this.$t('SeaExport.OperationCompanyCannotBeEmpty'))
        return
      }
      if (!this.isBatchUpdate) {
        if (!this.job.opDepartment || this.job.opDepartment <= 0) {
          this.$message.warning(this.$t('SeaExport.OperationDepartmentCannotBeEmpty'))
          return
        }
      }
      const form = {}
      form.opOffice = this.job.opOffice || 0
      form.op = this.job.op || 0
      if (this.job.opDepartment && this.job.opDepartment > 0) {
        form.opDepartment = this.job.opDepartment || 0
      }
      form.csr = this.job.csr || 0
      form.dc = this.job.dc || 0
      form.bookingTerm = this.job.bookingTerm
      form.bookingAgent = this.job.bookingAgent || 0
      form.remarks = this.job.remarks
      if (BookingTerm.OS_BOOKING_TYPE.code === this.job.bookingTerm) {
        form.scNo = this.job.scNo
        if (this.job.cargoChineseName && this.job.cargoChineseName.trim().length > 0) {
          form.cargoEnglishName += '\r'
        }
      }
      form.differentForm = this.differentForm
      this.submitCallBack(form)
      this.handleClose()
    },
    handleClose() {
      this.$emit('closePageHandler')
    }
  }
}
</script>
<style lang="scss">
  .cargo-form-dialog{
    .el-dialog{
      &__header,&__body,&__footer{
        padding:10px 15px!important;
      }
      &__title{
        vertical-align: middle;
      }
      &__headerbtn{
        top:15px;
        right:15px;
      }
    }
  }
  .cargo-form{
    .el-form-item {
      &.red-input{
        .el-input__inner{
          color: #E9650E;
        }
      }
      &__content{
        width: auto!important;
      }
      &.label-none {
        .el-form-item__content{
          margin-left: 0;
        }
      }
    }
  }
</style>
